var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-radio-list",class:_vm.inputClass},_vm._l((_vm.radios),function(value,key){return _c('label',{key:key,staticClass:"m-radio"},[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"value":key}}),_vm._v("\n        "+_vm._s(value)+"\n        "),_c('span')])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69bba74b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/form/inputs/RadioComponent.vue
// module id = null
// module chunks = 